import React from 'react'
import { lu } from '../../data/reportData';
import { TITLE, TAB, H1, H1_TX, H2, H2_1, TB_LIST, TXB, TXR, TXR_B, TXR_B1, TXR_I, TXR_II, TXC, TXC_B, TXC_B1, TX_B, TX_BI, TXC_I, TXC_I1, CK, CK_H2, CK1, CK1_I, YN, YN1, TCH } from "../../styles/urar-styles";
import { IMAGE, IMAGE_1, COMMENTARY, EXHIBITS, TABLE, TITLE_ADD, SUM_HD, SIG_B, TB_SCA_SUB_H1, TB_SUB_H1_R, TB_SCA_H2 } from "../../styles/urar-styles";
import { ADDD } from './ADDD';


export function PROPERTY_UNIT({unit}) {
	//console.log("PropertyUnit: ", unit);

	return (
		<>
			<h1>PROPERTY_UNIT</h1>
		</>
	)
}
